import React from "react";
import { Link } from "react-router-dom";
import { Lock, Play, Eye } from "lucide-react";
import StatusBadge from "./StatusBadge";
import { timeAgo } from "@/lib/time";

export default function VideoCard({ video }) {
  const isLocked = video.status === "patreon_exclusive";
  return (
    <Link
      to={`/videos/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className="group relative block rounded-2xl overflow-hidden bg-[#0e0e0e] border border-white/5 hover:border-[#E50914]/40 transition-all duration-300 hover-glow"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail || "https://images.unsplash.com/photo-1616588589676-62b3bd4ff6d2?w=800&q=80"}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
        {isLocked && (
          <div className="absolute inset-0 backdrop-blur-md bg-black/50 flex items-center justify-center">
            <div className="flex flex-col items-center gap-2 text-[#E50914]">
              <Lock className="w-8 h-8" strokeWidth={2.5} />
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold">Patreon Only</span>
            </div>
          </div>
        )}
        {!isLocked && (
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="w-14 h-14 rounded-full bg-[#E50914] flex items-center justify-center shadow-[0_0_30px_rgba(229,9,20,0.6)]">
              <Play className="w-6 h-6 text-white fill-white" />
            </div>
          </div>
        )}
        <div className="absolute top-3 left-3">
          <StatusBadge status={video.status} />
        </div>
      </div>
      <div className="p-4 space-y-2">
        <h3 className="font-display font-bold text-base leading-tight text-white group-hover:text-[#E50914] transition-colors line-clamp-2">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-zinc-400">
          <span className="flex items-center gap-1.5">
            <Eye className="w-3.5 h-3.5" />
            {(video.views || 0).toLocaleString()} views
          </span>
          <span className="text-zinc-600">·</span>
          <span>{timeAgo(video.publish_date)}</span>
        </div>
      </div>
    </Link>
  );
}
